import React from "react";
import { styled } from '@mui/material/styles';
import socialProofStyles from './SocialProofStyles';
import { ReactComponent as SocialProofSVG } from '../../icons/GoogleSvg.svg';

type SocialProofProps = {

};

const StyledSocialProof = styled('section')(({ theme }) => socialProofStyles);

const componentSlots = [
  {
    title: '100+',
    description: 'clientes satisfechos'
  },
  {
    title: '15',
    description: 'años de experiencia'
  }
];

const altTitle = 'CONFIANZA DE CLIENTES';
const title = 'Lo que nos hace especiales';

const SocialProof: React.FC<SocialProofProps> = () => (
  <StyledSocialProof className="py-8 lg:py-0">
      <div className="max-w-screen-md mx-auto flex flex-col items-center py-8 lg:pt-16">
        <p id="social-proof-alt-title" className="text-xs font-medium mb-2">{altTitle}</p>
        <p id="social-proof-title" className="text-3xl font-extrabold text-center mx-6">{title}</p>
      </div>
      <div className="max-w-screen-xl px-4 py-8 mx-auto text-center lg:py-16 lg:px-6">
        <dl className="grid max-w-screen-md gap-8 mx-auto sm:grid-cols-3">
            {componentSlots.map((item, index) => <div key={index} className="flex flex-col items-center justify-center">
                <dt id="social-proof-slot-title" className="mb-2 text-3xl md:text-4xl font-extrabold">{item.title}</dt>
                <dd id="social-proof-slot-description" className="font-light">{item.description}</dd>
            </div>)}
            <div className="flex flex-row items-center justify-center" id="social-proof-google-rating">
              <SocialProofSVG className='h-12 w-16 py-3' href=""/>
              <div>
                <div className="whitespace-nowrap"><span className="text-yellow-500">★★★★★ </span><span className="social-proof-text">(4.8)</span></div>
                <a href="https://google.com" className="font-light whitespace-nowrap" id="social-proof-google-rating-text" target="_blank" rel="noreferrer">Google Rating</a>
              </div>
            </div>
        </dl>
      </div>
    </StyledSocialProof>
);

export default SocialProof;